import {
    Bell, Trophy, CheckCircle, UserPlus, TrendingUp, Banknote, Users, Target, XCircle, Clock,
    AlertTriangle, AlertCircle, Send, FileText, Zap, MessageSquare, MessageCircle, AtSign, Smile,
    Calendar, BookOpen, ClipboardCheck, Mail, MailCheck, Lightbulb, Gauge, AlarmClock, Hourglass,
    CheckSquare, RefreshCw,
} from 'lucide-react';

export const ICON_MAP = {
    'trophy': Trophy,
    'check-circle': CheckCircle,
    'user-plus': UserPlus,
    'trending-up': TrendingUp,
    'banknote': Banknote,
    'users': Users,
    'target': Target,
    'x-circle': XCircle,
    'clock': Clock,
    'alert-triangle': AlertTriangle,
    'alert-circle': AlertCircle,
    'bell': Bell,
    'send': Send,
    'file-text': FileText,
    'zap': Zap,
    'message-square': MessageSquare,
    'message-circle': MessageCircle,
    'at-sign': AtSign,
    'smile': Smile,
    'calendar': Calendar,
    'book-open': BookOpen,
    'clipboard-check': ClipboardCheck,
    'mail': Mail,
    'mail-check': MailCheck,
    'lightbulb': Lightbulb,
    'gauge': Gauge,
    'alarm-clock': AlarmClock,
    'hourglass': Hourglass,
    'check-square': CheckSquare,
    'refresh-cw': RefreshCw,
};

export const COLOR_STYLES = {
    success: { bg: 'bg-emerald-100', icon: 'text-emerald-600' },
    gold: { bg: 'bg-yellow-100', icon: 'text-yellow-600' },
    error: { bg: 'bg-red-100', icon: 'text-red-600' },
    warning: { bg: 'bg-amber-100', icon: 'text-amber-600' },
    neutral: { bg: 'bg-slate-100', icon: 'text-slate-600' },
};

export const NOTIFICATION_FILTERS = [
    { value: 'all', label: 'Toutes', icon: Bell },
    { value: 'prospect', label: 'Prospects', icon: UserPlus },
    { value: 'commission', label: 'Commissions', icon: Banknote },
    { value: 'pipeline', label: 'Pipeline', icon: TrendingUp },
    { value: 'dossier', label: 'Dossiers', icon: FileText },
    { value: 'hub', label: 'Projets', icon: CheckSquare },
];

export const TYPE_TO_CATEGORY = {
    'new_prospect': 'prospect',
    'prospect_signed': 'prospect',
    'prospect_lost': 'prospect',
    'prospect_stale': 'prospect',
    'stage_advanced': 'pipeline',
    'dossier_validated': 'dossier',
    'dossier_transmis': 'dossier',
    'commission_earned': 'commission',
    'commission_validated': 'commission',
    'hub_wall_message': 'hub',
    'hub_wall_mention': 'hub',
    'hub_wall_comment': 'hub',
    'hub_task_assigned': 'hub',
    'hub_proposition': 'hub',
    'hub_space_updated': 'hub',
    'hub_stage_moved': 'hub',
    'hub_project_closed': 'hub',
    'hub_project_reopened': 'hub',
    'hub_overload': 'hub',
    'hub_overdue': 'hub',
    'hub_stuck': 'hub',
};

export const notificationDestination = (n) =>
    n.link_url
    || (n.target_type === 'prospect' && n.target_id ? `/prospects/${n.target_id}` : null)
    || (n.target_type === 'task' && n.target_id ? `/tasks?highlight=${n.target_id}` : null)
    || (n.target_type === 'idea' ? '/boite-a-idees' : null)
    || (n.target_type === 'feed_post' || (n.type || '').startsWith('feed') ? '/feed' : null);
